import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notEmptyObjectValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (!Object.keys(value).length) {
        return { emptyObject: true };
      }
    }

    return null;
  };
}
